import React from "react";
import {DashboardJobOrderCount} from "../../types/DashboardJobOrderCount";
import {JobOrderRow} from "./JobOrderRow";
import {useExpandCollapseBox} from "../common/hooks/useExpandCollapseBox";

interface DispatchOrdersBoxProps {
    jobOrderCounts: DashboardJobOrderCount[];
    expanded: boolean;
    onToggleExpanded: (expanded: boolean) => void;
}

const COLLAPSED_JOB_ORDER_COUNT = 6;

let renderJobOrderRows = function (jobOrderCounts: DashboardJobOrderCount[]) {
    return jobOrderCounts.map((jobOrderCount) => (
        <JobOrderRow key={jobOrderCount.job_id} jobOrderCount={jobOrderCount}/>
    ));
};

export let DispatchOrdersBox = function (props: DispatchOrdersBoxProps) {
    let {boxRef, overlayRef, contentRef, renderExpanded, reservedSlotHeight} = useExpandCollapseBox({expanded: props.expanded, contentDependency: props.jobOrderCounts});
    // The collapsed state keeps the two-column arrangement, so the split is computed from the displayed jobs rather than the full list.
    let displayedJobOrderCounts = renderExpanded ? props.jobOrderCounts : props.jobOrderCounts.slice(0, COLLAPSED_JOB_ORDER_COUNT);
    // Jobs flow down the left column then the right; the left column holds the first ceil(n/2).
    let leftColumnCount = Math.ceil(displayedJobOrderCounts.length / 2);
    let leftColumnJobOrderCounts = displayedJobOrderCounts.slice(0, leftColumnCount);
    let rightColumnJobOrderCounts = displayedJobOrderCounts.slice(leftColumnCount);
    return (
        <div className="dispatch-orders-box-slot" style={reservedSlotHeight ? {minHeight: reservedSlotHeight} : undefined}>
        <div ref={boxRef} className={renderExpanded ? "dispatch-orders-box expanded" : "dispatch-orders-box"}>
            {renderExpanded && (
                <div ref={overlayRef} className="dispatch-orders-box-overlay" onClick={() => props.onToggleExpanded(false)}/>
            )}
            <div ref={contentRef} className="dispatch-orders-box-content">
                <div className="dispatch-orders-box-header">
                    <div className="dispatch-orders-box-title">Dispatch Orders</div>
                </div>
                <div className="dashboard-box-divider"/>
                {props.jobOrderCounts.length === 0 ? (
                    <div className="dispatch-orders-box-empty">No dispatch orders found.</div>
                ) : (
                    <div className="dispatch-orders-box-columns">
                        <div className="dispatch-orders-box-column">{renderJobOrderRows(leftColumnJobOrderCounts)}</div>
                        <div className="dispatch-orders-box-column">{renderJobOrderRows(rightColumnJobOrderCounts)}</div>
                    </div>
                )}
                <img
                    className="dispatch-orders-box-toggle-icon"
                    src={renderExpanded ? "/static/images/collapse-arrows-textcolor.svg" : "/static/images/expand-arrows-textcolor.svg"}
                    alt={renderExpanded ? "Collapse" : "Expand"}
                    onClick={() => props.onToggleExpanded(!renderExpanded)}
                />
            </div>
        </div>
        </div>
    );
};
